
export const getRoleBadgeColor = (role: string) => {
  switch (role) {
    case 'superadmin': return 'bg-red-100 text-red-800';
    case 'member': return 'bg-blue-100 text-blue-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const formatRoleDisplay = (role: string) => {
  switch (role) {
    case 'superadmin': return 'Super Admin';
    case 'member': return 'Member';
    default: return role;
  }
};
